import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const inputVariants = cva(
  'border border-[var(--fl-border)] rounded-lg bg-[var(--fl-surface)] text-[var(--fl-text-1)] placeholder:text-[var(--fl-text-3)] focus:outline-none focus:ring-2 focus:ring-[var(--fl-heading)]/20 focus:border-[var(--fl-heading)] transition-colors disabled:opacity-50 disabled:cursor-not-allowed',
  {
    variants: {
      size: {
        default: 'w-full px-3 py-2.5 text-sm',
        sm: 'px-2.5 py-1.5 text-xs',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
)

export interface InputProps
  extends
    Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, size, type = 'text', ...props }, ref) => {
    return (
      <input ref={ref} type={type} className={cn(inputVariants({ size }), className)} {...props} />
    )
  }
)
Input.displayName = 'Input'

export { Input, inputVariants }
